module.exports = __webpack_public_path__ + "static/media/visual_appraisal_zoom.2d5cf9e3.png";